import styled from 'styled-components';
import CharacterCount from './CharacterCount.jsx';
import { ResponseLabel, ResponseLabelWrapper } from './ResponseLabel';

const ResponseInput = ({
  characterLimit,
  responseText,
  onChange,
  label,
  placeholder,
  isDisabled = false,
}) => {
  return (
    <>
      <ResponseLabelWrapper>
        <ResponseLabel>{label}</ResponseLabel>
        <CharacterCount
          characterLimit={characterLimit}
          characters={responseText.length}
        />
      </ResponseLabelWrapper>
      <Input
        maxLength={characterLimit}
        placeholder={placeholder}
        onChange={({ target: { value } }) => onChange(value)}
        disabled={isDisabled}
      />
    </>
  );
};

export default ResponseInput;

const Input = styled.textarea`
  height: 100px;
  padding: 11px;
  font-size: 14px;
  resize: none;
`;
